export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const API_URL = config.public.apiUrl;

  const logout = async (): Promise<void> => {
    try {
      const response: Response = await fetch(`${API_URL}/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const cloudflareTurnstile = async (token: string): Promise<boolean> => {
    try {
      const response: Response = await fetch(`${API_URL}/cfturnstile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ turnstileToken: token }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: { message: string } = await response.json();
      return data.message === "Turnstile verification successful";
    } catch (error) {
      console.error('Error verifying Turnstile token:', error);
      return false;
    }
  };

  return {
    provide: {
      session: { logout, cloudflareTurnstile },
    },
  };
});